import {
  faBookmark,
  faFileContract,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import createField from "../../../utils/factory/createField";

export const filterFields = [
  {
    section: "Filtros para o relatório",
    fields: [
      createField({
        id: "filter.customer_id",
        label: "Cliente Contratante",
        placeholder: "Selecione o cliente contratante",
        type: "select",
        icon: faUser,
        isClearable: true,
      }),
      createField({
        id: "filter.contract_id",
        label: "Contrato",
        placeholder: "Selecione o contrato do cliente",
        type: "select",
        icon: faFileContract,
        isClearable: true,
      }),
      createField({
        id: "filter.with_reserved",
        label: "Com Equipamentos Reservados?",
        placeholder: "Selecione Sim ou Não",
        type: "select",
        icon: faBookmark,
        fullWidth: true,
      }),
    ],
  },
];
